import {map} from 'lodash'


const INITIAL_STATE = {
  links: {},
  results: [],
  isFetching: false,
  triggerSearch: false
}




const serarchVenueReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) { 
  case 'NEW_SEARCH_REQUESTED':
    return {
      ...state, 
      triggerSearch: true
    }
  case 'VENUE_SEARCH_FETCHING':
    return {
      ...state,
      isFetching: true
    }
  case 'VENUE_SEARCH_FETCH_COMPLETED':
    return {
      ...state,
      isFetching: false,
      triggerSearch: false
    }
  case 'VENUE_SEARCH_SUCCESS':
    return {
      links: action.payload.links || {},
      results: map(action.payload.data, 'id'),
      isFetching: false,
      triggerSearch: false
    }
  case 'VENUE_PAGINATION_SEARCH_SUCCESS':
    return {
      links: action.payload.links || {},
      results: [...new Set([...state.results, ...map(action.payload.data, 'id')])],
      isFetching: false,
      triggerSearch: false
    }
  default:
    return state
  }
}


export default serarchVenueReducer

